<script>
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrKontrolIsbirlikci from "@/models/StrKontrolIsbirlikci";
export default {
  mixins: [Api, Sabit, StrKontrolIsbirlikci],
  props: ["Id", "AddEdit", "TanimId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: {},
      TableData: [],
    };
  },
  components: {
    Loader,
    BirimSecimi,
    formcombobox,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      if (this.AddEdit == "Add") {
        this.FormData.TanimId = this.TanimId;
      }
      this.FormData.Tip = 1;
    },
    TanimId() {
      if (this.AddEdit == "Add") {
        this.FormData.TanimId = this.TanimId;
      }
    },
    AddEdit() {},
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.FormData.BirimIds[0] == 1) {
          this.FormData.BirimIds.splice(0, 1);
        }

        if (this.AddEdit == "Add") {
          this.Post("StrKontrolIsbirlikci", this.FormData);
          this.$bvModal.hide("StrKontrolIsbirlikci");
        } else {
          this.Update("StrKontrolIsbirlikci", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("StrKontrolIsbirlikci");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrKontrolIsbirlikci"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrKontrolIsbirlikci.AddEdit.FormTitleEdit')
          : $t('StrKontrolIsbirlikci.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <formcombobox
          :FormDataType="FormDataType.TanimId"
          :Value="FormData.TanimId"
          :v="$v.FormData.TanimId"
          @input="FormData.TanimId = $event"
        />



                <BirimSecimi
          title="Sorumlu Birimler"
          :title_position="'mb-3'"
          :selected="FormData.SorumluBirimIds"
          :FormDataType="FormDataType.SorumluBirimIds"
          :v="$v.FormData.SorumluBirimIds"
          :multiple="true"
          :BirimTipId="null"
          @Secilmis_Idler="FormData.SorumluBirimIds = $event"
        />

        <BirimSecimi
          title="İş Birliği Yapılacak Birimler"
          :title_position="'mb-3'"
          :selected="FormData.BirimIds"
          :FormDataType="FormDataType.BirimIds"
          :v="$v.FormData.BirimIds"
          :multiple="true"
          :BirimTipId="null"
          @Secilmis_Idler="FormData.BirimIds = $event"
        />

     <!--   <formcombobox
          :FormDataType="FormDataType.Tip"
          :Value="FormData.Tip"
          :v="$v.FormData.Tip"
          @input="FormData.Tip = $event"
          disabled
        /> -->
        <button class="btn btn-primary" type="submit">
          {{ $t("StrKontrolIsbirlikci.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
